import { statusReason } from '../constants/api-responses';

const formatQuestionData = responseData => {
    const questionSet = responseData.questionSet;
    const payload = {
        conversationId: responseData.conversationId,
        questionSetId: questionSet.questionSetId,
        question: questionSet.questions[0],
        productType: responseData.productType
    };

    return payload;
};

const formatIntakeForm = data => {
    const bd = data.birthday.split('/');
    data.dobMonth = bd[0];
    data.dobDay = bd[1];
    data.dobYear = bd[2];
    delete data.birthday;

    if (data.suffix === 'None') {
        data.suffix = '';
    }

    if (data.address2 === ' ') {
        data.address2 = '';
    }

    return data;
};

const isFinalFailure = transactionReasonCode => {
    let failure = false;
    const failureCode = transactionReasonCode && transactionReasonCode.code ? transactionReasonCode.code : null;
    failure = Object.values(statusReason).includes(failureCode);
    return failure;
};

const isFileUploadFailure = transactionReasonCode => {
    const failureCode = transactionReasonCode && transactionReasonCode.code ? transactionReasonCode.code : null;
    return failureCode === 'filesize';
};



const formatAnswerResponse = ({ answer, state }) => {
    const conversationId = state.conversationId;
    const questionSetId = state.questionSetId;
    const questionId = state.question.questionId;
    const ccpaCaseModel = state.ccpaModel;

    const response = {
        ccpaCaseModel,
        conversationId,
        answers: {
            questionSetId,
            questions: [
                {
                    questionId,
                    choices: [
                        {
                            choice: answer
                        }
                    ]
                }
            ]
        }
    };
    return response;
};

export { formatQuestionData, formatAnswerResponse, formatIntakeForm, isFinalFailure, isFileUploadFailure };